import React, { ReactElement } from 'react';
import { Button, BUTTON_STYLE_TYPE } from 'b2b-components/theme/components/Button';
import { ComponentType, Props } from './';
import './ModalContent.scss';

export const ModalContent: ComponentType = ({
  data,
  onDismiss,
  buttonLabel,
}: Props): ReactElement => (
  <>
    {data.title && <h3 className='ModalContent-Title'>{data.title}</h3>}
    {data.subtitle && (
      <h5 className='ModalContent-Subtitle'>{data.subtitle}</h5>
    )}
    <div className='ModalContent-Content'>
      <div
        className="ModalContent-TextWrapper"
        dangerouslySetInnerHTML={{
          __html: data.text,
        }}
      />
      {data.image && (
        <div className="ModalContent-ImageWrapper">
          <img
            className="ModalContent-Image"
            src={data.image.url}
            alt={data.image.title}
          />
        </div>
      )}
    </div>
    <div className="ModalContent-ButtonsWrapper">
      <Button
        className="ModalContent-ButtonClose"
        styleType={BUTTON_STYLE_TYPE.primary}
        onClick={onDismiss}
      >
        {data.button_label || buttonLabel}
      </Button>
    </div>
  </>
);
